/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const teamSearchFiltersSchema = z.object({
  cursor: z.string().nullish(),
  limit: z.int().nullish(),
  loopIds: z.array(z.int()).nullish(),
  query: z.string(),
  roleIds: z.array(z.int()).nullish(),
  skillIds: z.array(z.int()).nullish(),
  sortBy: z.enum(['ID', 'NAME', 'DESCRIPTION', 'CREATED_AT', 'UPDATED_AT', 'MEMBERSHIP_COUNT']),
  sortDirection: z.enum(['ASC', 'DESC']),
});
